/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const ExpanderContentContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: `${gridSize() / 4}px`,
  paddingRight: `${gridSize() / 4}px`,
});

export const EmptyStateContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const EmptyStateImage = styled.img({
  marginTop: `${gridSize() * 2}px`,
});

export const EmptyStateHeadingText = styled.div({
  font: token('font.heading.xsmall'),
  marginBottom: `${gridSize() * 2}px`,
});

export const EmptyStateBodyText = styled.div({
  font: token('font.body'),
  marginBottom: `${gridSize() * 2}px`,
  width: `${gridSize() * 22}px`,
  textAlign: 'center',
});

export const EmptyStateButton = styled(Button)({
  marginBottom: `${gridSize() * 2}px`,
});

export const ShowMoreButton = styled.button({
  borderStyle: 'none',
  marginTop: `${gridSize()}px`,
  marginBottom: `${gridSize()}px`,
  padding: 0,
  height: `${gridSize() * 3}px`,
});

export const ShowHideButton = styled.button({
  borderStyle: 'none',
  padding: 0,
  height: `${gridSize() * 2}px`,
});

export const CreatedInPrContainerLargeTopMargin = styled.div({
  marginTop: `${gridSize() * 3}px`,
});

export const CreatedInPrContainerSmallTopMargin = styled.div({
  marginTop: `${gridSize() * 0.5}px`,
});

export const CreatedInPrHeadingContainer = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginLeft: `${gridSize()}px`,
  marginBottom: `${gridSize()}px`,
  marginRight: `${gridSize()}px`,
});

export const ShowMoreTextContainer = styled.div({
  font: token('font.body'),
  color: token('color.text.information'),
});

export const ShowHideTextContainer = styled.div({
  font: token('font.body.small'),
  color: token('color.text.subtlest'),
});

export const CreatedInPrTextContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  font: token('font.heading.xxsmall'),
  color: token('color.text.subtlest'),
  marginTop: 0,
});

export const Divider = styled.div({
  height: '1px',
  backgroundColor: token('color.border'),
  marginTop: `${gridSize()}px`,
  marginLeft: `-${gridSize() * 1.25}px`,
  marginRight: `-${gridSize() * 1.25}px`,
});
